import classNames from 'classnames';
import { omit } from 'lodash-es';

type HeaderProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLHeadingElement>, HTMLHeadingElement> & {
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'div';
};

export const Header1 = (props: HeaderProps) => {
  const Heading = props.as ?? 'h1';
  return (
    // eslint-disable-next-line jsx-a11y/heading-has-content
    <Heading {...omit(props, 'className', 'as')} className={classNames(props.className, 'tds-header-1')} />
  );
};

export const Header2 = (props: HeaderProps) => {
  const Heading = props.as ?? 'h2';
  return (
    // eslint-disable-next-line jsx-a11y/heading-has-content
    <Heading {...omit(props, 'className', 'as')} className={classNames(props.className, 'tds-header-2')} />
  );
};

export const Header3 = (props: HeaderProps) => {
  const Heading = props.as ?? 'h3';
  return (
    // eslint-disable-next-line jsx-a11y/heading-has-content
    <Heading {...omit(props, 'className', 'as')} className={classNames(props.className, 'tds-header-3')} />
  );
};

export const Header4 = (props: HeaderProps) => {
  const Heading = props.as ?? 'h4';
  return (
    // eslint-disable-next-line jsx-a11y/heading-has-content
    <Heading {...omit(props, 'className', 'as')} className={classNames(props.className, 'tds-header-4')} />
  );
};

type SubheaderProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLHeadingElement>, HTMLHeadingElement> & {
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'div' | 'span';
};

export const Subheader = (props: SubheaderProps) => {
  const Heading = props.as ?? 'h1';
  return (
    // eslint-disable-next-line jsx-a11y/heading-has-content
    <Heading {...omit(props, 'className', 'as')} className={classNames(props.className, 'tds-subheader')} />
  );
};

type ParagraphProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLParagraphElement>, HTMLParagraphElement> & {
  as?: 'p' | 'div' | 'span';
};

export const Paragraph = (props: ParagraphProps) => {
  const Element = props.as ?? 'p';
  return (
    <Element {...omit(props, 'className', 'secondary', 'as')} className={classNames(props.className, 'tds-paragraph')} />
  );
};
